import Env from '../config/envConfig'

import {
  FacebookPostApi as FacebookPostApiClass,
  FacebookPageApi as FacebookPageApiClass,
  LinkedInPostApi as LinkedInPostApiClass,
  InstagramPostApi as InstagramPostApiClass,
  InstagramPageApi as InstagramPageApiClass,
  GooglePostApi as GooglePostApiClass,
  Configuration as SMConfiguration,
} from '@3m5/sm_publish-frontend-api'
import smModuleFetchApi from './smModuleFetchApi'

const BASE_PATH_API = Env.restBase

export const FacebookPostApi = new FacebookPostApiClass(new SMConfiguration({
  basePath: BASE_PATH_API,
  fetchApi: smModuleFetchApi(fetch),
}))

export const FacebookPageApi = new FacebookPageApiClass(new SMConfiguration({
  basePath: BASE_PATH_API,
  fetchApi: smModuleFetchApi(fetch),
}))

export const InstagramPostApi = new InstagramPostApiClass(new SMConfiguration({
  basePath: BASE_PATH_API,
  fetchApi: smModuleFetchApi(fetch),
}))

export const InstagramPageApi = new InstagramPageApiClass(new SMConfiguration({
  basePath: BASE_PATH_API,
  fetchApi: smModuleFetchApi(fetch),
}))

export const GooglePostApi = new GooglePostApiClass(new SMConfiguration({
  basePath: BASE_PATH_API,
  fetchApi: smModuleFetchApi(fetch),
}))

export const LinkedInPostApi = new LinkedInPostApiClass(new SMConfiguration({
  basePath: BASE_PATH_API,
  fetchApi: smModuleFetchApi(fetch),
}))
